<template>
  <div>
    <PageHeader title="Reports" :links="[
      { name: 'home', label: 'Home' },
      { name: 'reports', label: 'Reports' },
      { name: 'customerReport', label: 'Customer' },
    ]">
      <CheckBox :toggleVariable="showLegacyReports" @click="showLegacyReports = !showLegacyReports"
        label="Show Legacy Reports" />
    </PageHeader>
    <div class="home responsive-menu">
      <div v-if="!showLegacyReports && !isLoading" v-canAccess="reportRoles">
        <div class="responsive-menu__child responsive-menu__sub-section" v-for="(section, index) in reports"
          :key="index">
          <div class="section-base" v-canAccess="reportRoles">
            <div class="section-base__header space-between">
              <div class="section-base__header-name">
                <div>
                  <i class="fas fa-chart-line"></i>
                </div>
                <div>{{ section.subSection }}</div>
              </div>
            </div>
            <div class="slim">
              <div class="elevated-0 bordered spacer-responsive">
                <div v-for="report in section.reports" :key="report.slug">
                  <inline-button v-if="!report.legacyReportSlug" :to="{ name: 'customerReports', query: { name: report.slug } }"
                    type="plain-primary responsive-column" :label="report.name" />
                  <inline-button v-else :to="{ name: report.legacyReportSlug }"
                    type="plain-primary responsive-column" :label="report.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="responsive-menu__child responsive-menu__sub-section" v-if="showLegacyReports && !isLoading">
        <div class="section-base" v-canAccess="reportRoles">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>
                <i class="fas fa-chart-line"></i>
              </div>
              <div>Customer Information</div>
            </div>
          </div>
            <div class="padded elevated-0 bordered spacer-responsive">
              <inline-button :to="{ name: 'customerCreditMemoBalance' }" type="plain-primary responsive-column"
                label="Credit Memo Balance" />
              <inline-button :to="{ name: 'customerNotes' }" type="plain-primary responsive-column" label="Notes" />
            </div>
        </div>

        <div class="section-base" v-canAccess="reportRoles">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>
                <i class="fas fa-chart-line"></i>
              </div>
              <div>Customer Marketing</div>
            </div>
          </div>
            <div class="padded elevated-0 bordered spacer-responsive">
              <inline-button :to="{ name: 'customerNewCount' }" type="plain-primary responsive-column"
                label="New Customers" />
              <inline-button :to="{ name: 'customerZipCodeCount' }" type="plain-primary responsive-column"
                label="Zip Code Breakdown" />
              <inline-button :to="{ name: 'customerEmail' }" type="plain-primary responsive-column"
                label="Email Addresses" />
              <inline-button :to="{ name: 'customerLoyaltyStatus' }" type="plain-primary responsive-column"
                label="Loyalty Status" />
              <inline-button :to="{ name: 'customerLoyaltySignUp' }" type="plain-primary responsive-column"
                label="Loyalty Sign Up By Employee" />
            </div>
        </div>
      </div>
      <div class="responsive-menu__child responsive-menu__sub-section" v-if="showLegacyReports">
        <div class="section-base" v-canAccess="reportRoles">
          <div class="section-base__header space-between">
            <div class="section-base__header-name">
              <div>
                <i class="fas fa-chart-line"></i>
              </div>
              <div>Customer Usage</div>
            </div>
          </div>
            <div class=" padded elevated-0 bordered spacer-responsive">
              <inline-button :to="{ name: 'customerCanPay' }" type="plain-primary responsive-column" label="CanPay" />
              <inline-button :to="{ name: 'customerCoupon' }" type="plain-primary responsive-column" label="Coupons" />
              <inline-button :to="{ name: 'customerGiftCard' }" type="plain-primary responsive-column"
                label="Gift Cards" />
              <inline-button :to="{ name: 'customerTransactFirst' }" type="plain-primary responsive-column"
                label="Transact First" />
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportRoles } from "@/constants/roles";
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import CheckBox from "@/components/CheckBox.vue";

export default {
  name: "reports",
  data() {
    return {
      reportRoles,
      showLegacyReports: false,
    };
  },
  components: {
    PageHeader,
    CheckBox
  },
  created: function () {
    this.setPageTitle("Reports");
  },
  mounted: function () {
    this.getReportSettings();
  },
  watch: {
    reportSettings: {
      handler(newVal) {
        this.showLegacyReports = newVal?.showLegacyReports || false;
      },
    },
  },
  computed: {
    ...mapGetters({
      reportSettings: "reports/reportSettings",
      isLoading: "reports/isLoading",
    }),
    reports() {
      const groupedReports = this.reportSettings?.reportConfigs
        ?.filter(report => report.section === "Customer Reports")
        .reduce((acc, report) => {
          const subSection = report.subSection || 'Uncategorized';
          if (!acc[subSection]) {
            acc[subSection] = [];
          }
          acc[subSection].push(report);
          return acc;
        }, {}) ?? [];

      const arr = Object.entries(groupedReports).map(([subSection, reports]) => ({
        subSection,
        reports,
      }));
      return arr;
    },
  },
  methods: {
    ...mapActions({
      getReportSettings: "reports/getReportSettings",
    }),
  }
};
</script>

<style lang="scss">
.slim {
  display: flex;
  flex-direction: column;
  gap: 0rem;

  &>* {
    padding-left: 1rem;
  }
}
</style>
